import { SearchBarItem } from "../components/SearchBar/types";
import { InlineEditTableColumn } from "../components/Table/types";
import { CommerceInfo, PaginationState, ToastMessage } from "../types";
import { validateEmail } from "@/utils/emailValidation";

export const COMMECE_INFO_TABLE_COLUMNS: InlineEditTableColumn[] = [
  { id: "cedRnc", label: "Cédula/RNC", editable: false, columnType: "text" },
  {
    id: "commercialName",
    label: "Nombre Comercial",
    editable: true,
    columnType: "text",
    getErrors: (value) => {
      if (!value?.trim()) return "El nombre comercial es requerido";
      return null;
    },
  },
  {
    id: "legalName",
    label: "Nombre Legal",
    editable: false,
    columnType: "text",
  },
  {
    id: "ownerName",
    label: "Representante",
    editable: false,
    columnType: "text",
  },
  {
    id: "email",
    label: "Correo Electrónico",
    editable: true,
    columnType: "text",
    getErrors: (value) => {
      if (!value) return "El correo es requerido";
      if (!validateEmail(value)) return "El correo no es válido";
      return null;
    },
  },
  {
    id: "commercialCategory",
    label: "Categoría Comercial",
    editable: true,
    columnType: "select",
  },
  {
    id: "overrideCardnet",
    label: "Override Cardnet",
    editable: true,
    columnType: "boolean",
  },
];

export const MOCK_COMMERCES: CommerceInfo[] = [
  {
    id: "1",
    cedRnc: "001-0123456-7",
    commercialName: "Farmacia del Pueblo",
    legalName: "Farmacia del Pueblo SRL",
    ownerName: "Juan Pérez",
    email: "contacto@farmaciapueblo.do",
    commercialCategory: "Salud",
    overrideCardnet: true,
  },
  {
    id: "2",
    cedRnc: "401-0234567-8",
    commercialName: "Super Mercado Central",
    legalName: "Comercial Central SA",
    ownerName: "María García",
    email: "info@supermercado.do",
    commercialCategory: "Retail",
    overrideCardnet: false,
  },
  {
    id: "3",
    cedRnc: "131-0345678-9",
    commercialName: "Tech Solutions RD",
    legalName: "Tech Solutions República Dominicana SAS",
    ownerName: "Carlos Rodríguez",
    email: "ventas@techsolutions.do",
    commercialCategory: "Tecnología",
    overrideCardnet: true,
  },
  {
    id: "4",
    cedRnc: "501-0456789-0",
    commercialName: "Restaurante La Cocina",
    legalName: "La Cocina Dominicana SRL",
    ownerName: "Ana Martínez",
    email: "reservas@lacocina.do",
    commercialCategory: "Gastronomía",
    overrideCardnet: false,
  },
  {
    id: "5",
    cedRnc: "001-0567890-1",
    commercialName: "Moda y Estilo",
    legalName: "Boutique Moda y Estilo SA",
    ownerName: "Luis Fernández",
    email: "contacto@modayestilo.do",
    commercialCategory: "Moda",
    overrideCardnet: true,
  },
];

export const SEARCH_COLUMNS: SearchBarItem[] = [
  { id: "cedRnc", label: "CED/RNC" },
  { id: "nombreLegal", label: "Nombre Legal" },
  { id: "nombreComercial", label: "Nombre Comercial" },
  { id: "correoElectronico", label: "Correo Electrónico" },
];

export const DEFAIULT_PAGINATION_STATE: PaginationState<CommerceInfo> = {
  pages: {},
  pagination: {
    page: 1,
    pageSize: 5,
    totalItems: 0,
    totalPages: 1,
  },
};

export const TOAST_DEFAULT_VALUE: ToastMessage = {
  message: "",
  open: false,
  type: "error",
};
